import Layout from "../components/Layout";
import { RedeemAtPVCTransaction } from "../components/_RedeemAtPVCTransaction";

const PvcTransactionPage = (props:any) => {
    return (
    <Layout>
        <RedeemAtPVCTransaction/>
    </Layout>
    )
}

export default PvcTransactionPage